export default __webpack_public_path__ + "static/media/sfaLogo.bb9ac401.svg";